import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18SearchPlaceholderG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
      fillRule: "evenodd",
      d: "M3.596 3.49a6.5 6.5 0 0 1 9.693 8.631l2.416 2.417a.625.625 0 1 1-.883.884l-2.4-2.4A6.5 6.5 0 0 1 3.596 3.49m.884.883a5.25 5.25 0 0 0 6.953 7.844l.175-.144.387-.332.315-.397a5.25 5.25 0 0 0-.247-6.806l-.158-.165a5.25 5.25 0 0 0-7.425 0"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18SearchPlaceholderG$1 = Svg18SearchPlaceholderG;

export { Svg18SearchPlaceholderG$1 as default };
